import GatewayService from '../GatewayService.js';
var classroomState = new GatewayService('classroom-state');

var fetchClassroomState = function fetchClassroomState(classKey, fileKey) {
  return classroomState.get("state/".concat(classKey, "/").concat(fileKey));
};

var saveClassroomState = function saveClassroomState(classKey, fileKey, body) {
  return classroomState.post("state/".concat(classKey, "/").concat(fileKey), body);
};

var batchFetchClassroomState = function batchFetchClassroomState(body, includeData) {
  return classroomState.post("state/batch-get?includeData=".concat(includeData), body);
};

var batchSaveClassroomState = function batchSaveClassroomState(body) {
  return classroomState.post("state/batch-post", body);
};

var fetchClassroomStateWithPrefix = function fetchClassroomStateWithPrefix(classKey, prefix) {
  return classroomState.get("state/".concat(classKey, "/all/").concat(prefix));
};

var deleteAllClassroomStateWithPrefix = function deleteAllClassroomStateWithPrefix(classKey, prefix) {
  return classroomState["delete"]("state/all/".concat(classKey, "/").concat(prefix));
};

export default {
  fetchClassroomState: fetchClassroomState,
  saveClassroomState: saveClassroomState,
  batchFetchClassroomState: batchFetchClassroomState,
  batchSaveClassroomState: batchSaveClassroomState,
  fetchClassroomStateWithPrefix: fetchClassroomStateWithPrefix,
  deleteAllClassroomStateWithPrefix: deleteAllClassroomStateWithPrefix
};